export default "__VITE_ASSET__BAfklOFa__"